module.exports = __webpack_public_path__ + "img/cyan_bean_cute_face.3e9ef279.png";